import React from "react";
import CartData from "./components/CartData";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";


const Cart = () => {

  let bearedToken: any;
  const [searchParams, setSearchParams] = useSearchParams();
  if (searchParams.has("token")) {
    bearedToken = searchParams.get("token");
  }
  // Set a cookie  [token]
  if (searchParams.has("token") && bearedToken !== null) {
    Cookies.set("cookieName", bearedToken);
  }

  let cartIdData: any;
  if (searchParams.has("cartId")) {
    cartIdData = searchParams.get("cartId");
  }
  // Set a cookie [cart id]
  if (searchParams.has("cartId") && cartIdData !== null) {
    Cookies.set("cartId", cartIdData);
  }


  // 1Day Delivery
  let oneDayDelivery: any;
  if (searchParams.has("oneDayDelivery")) {
    oneDayDelivery = searchParams.get("oneDayDelivery");
  }
  // Set a cookie [cart id]
  if (searchParams.has("oneDayDelivery") && oneDayDelivery !== null) {
    Cookies.set("oneDayDelivery", oneDayDelivery);
  }





  let utm_source : any ;
  let utm_medium : any ;
  let utm_campaign : any ;
  let utm_content : any;
  let utm_term : any;


  if (searchParams.has("utm_source")) {
    utm_source = searchParams.get("utm_source");
  }
  if (searchParams.has("utm_medium")) {
    utm_medium = searchParams.get("utm_medium");
  }
  if (searchParams.has("utm_campaign")) {
    utm_campaign = searchParams.get("utm_campaign");
  }
  if (searchParams.has("utm_content")) {
    utm_content = searchParams.get("utm_content");
  }
  if (searchParams.has("utm_term")) {
    utm_term = searchParams.get("utm_term");
  }



  if (searchParams.has("utm_source") && utm_source !== null) {
    Cookies.set("utmSource", utm_source);
  }

  if (searchParams.has("utm_medium") && utm_medium !== null) {
    Cookies.set("utmMedium", utm_medium);
  }

  if (searchParams.has("utm_campaign") && utm_campaign !== null) {
    Cookies.set("utmCampaign", utm_campaign);
  }
  
  if (searchParams.has("utm_content") && utm_content !== null) {
    Cookies.set("utmContent", utm_content);
  }

  if (searchParams.has("utm_term") && utm_term !== null) {
    Cookies.set("utmTerm", utm_term);
  }



  return (
    <div>
      <CartData />
    </div>
  );
};

export default Cart;
